import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Crown, BadgeCheck, Trophy } from "lucide-react";

export default function CreatorLeague() {
  const [period, setPeriod] = useState("weekly");
  const [category, setCategory] = useState("all");
  const [data, setData] = useState({ items: [], categories: ["all"] });

  useEffect(() => {
    api.get(`/creator-league?period=${period}&category=${category}`).then(r => setData(r.data));
  }, [period, category]);

  return (
    <div className="px-4 py-6">
      <div className="flex items-center gap-2 mb-1">
        <Crown className="w-7 h-7 text-[#A855F7]"/>
        <h1 className="font-outfit font-extrabold text-3xl tracking-tighter">Creator League</h1>
      </div>
      <p className="text-white/60 text-sm mb-4">Top creators by gift earnings</p>

      <div className="flex gap-2 mb-3">
        <button onClick={()=>setPeriod("weekly")} data-testid="cl-weekly" className={`flex-1 py-2 rounded-full text-sm font-bold border ${period==="weekly"?"border-[#A855F7] bg-[#A855F7]/10 text-[#A855F7]":"border-white/10 bg-white/5"}`}>Weekly</button>
        <button onClick={()=>setPeriod("monthly")} data-testid="cl-monthly" className={`flex-1 py-2 rounded-full text-sm font-bold border ${period==="monthly"?"border-[#A855F7] bg-[#A855F7]/10 text-[#A855F7]":"border-white/10 bg-white/5"}`}>Monthly</button>
      </div>

      <div className="flex gap-1.5 overflow-x-auto scrollbar-hide mb-4 -mx-4 px-4">
        {data.categories.map(c => (
          <button key={c} onClick={()=>setCategory(c)} data-testid={`cl-cat-${c}`}
            className={`flex-shrink-0 px-3 py-1.5 rounded-full text-xs font-semibold border capitalize ${category===c?"border-[#FF7A00] bg-[#FF7A00]/10 text-[#FF7A00]":"border-white/10 bg-white/5 text-white/70"}`}>
            {c}
          </button>
        ))}
      </div>

      <div className="space-y-2" data-testid="cl-list">
        {data.items.length === 0 && (
          <div className="text-center py-12 text-white/50">
            <Trophy className="w-10 h-10 mx-auto mb-2 opacity-50"/>
            <p>No data yet for this period</p>
          </div>
        )}
        {data.items.map(it => (
          <Link key={it.user.id} to={`/u/${it.user.id}`} data-testid={`cl-row-${it.rank}`}
            className="flex items-center gap-3 p-3 rounded-2xl bg-white/5 border border-white/10 active:scale-[0.99]">
            <div className={`w-9 h-9 rounded-full flex items-center justify-center font-bold ${it.rank<=3?"bg-gradient-to-br from-[#FF7A00] to-[#A855F7] text-black":"bg-white/10"}`}>
              {it.rank<=3 ? (it.rank===1?"🥇":it.rank===2?"🥈":"🥉") : `#${it.rank}`}
            </div>
            <img src={it.user.avatar} className="w-10 h-10 rounded-full"/>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-1">
                <span className="font-bold truncate">@{it.user.username}</span>
                {it.user.verified && <BadgeCheck className="w-3.5 h-3.5 text-[#00E5FF]"/>}
              </div>
              <div className="text-[10px] text-white/60">{it.label}</div>
            </div>
            <div className="text-[#FF7A00] font-bold text-sm">{it.secondary}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
